import { render } from "./DVRVideoListItem.vue?vue&type=template&id=16917507&scoped=true"
import script from "./DVRVideoListItem.vue?vue&type=script&lang=js"
export * from "./DVRVideoListItem.vue?vue&type=script&lang=js"

import "./DVRVideoListItem.vue?vue&type=style&index=0&id=16917507&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16917507"],['__file',"src/components/ui/DVRVideoListItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "16917507"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('16917507', __exports__)) {
    api.reload('16917507', __exports__)
  }
  
  module.hot.accept("./DVRVideoListItem.vue?vue&type=template&id=16917507&scoped=true", () => {
    api.rerender('16917507', render)
  })

}


export default __exports__